import styled, { css } from 'styled-components';

import { ITheme } from 'shared/presentation/contexts';

export type TVariant = 'default' | 'primary';

const VARIANT_COLORS: Record<
  TVariant,
  (theme: ITheme) => { background: string; icon: string }
> = {
  default: theme => ({
    background: theme.palette.neutral[50],
    icon: theme.palette.text.main,
  }),
  primary: theme => ({
    background: theme.palette.primary.main,
    icon: theme.palette.text.white,
  }),
};

export const Container = styled.nav<{ variant: TVariant }>`
  ${({ theme, variant }) => {
    const variantValue = VARIANT_COLORS[variant](theme);

    return css`
      display: flex;
      padding: ${theme.layout.spacing(2, 1.5)};
      align-items: center;
      gap: ${theme.layout.spacing(2)};

      background-color: ${variantValue.background};

      svg {
        color: ${variantValue.icon};
      }
    `;
  }}
`;

export const DrawerButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 1.5rem;
  color: ${({ theme }) => theme.palette.text.main};
`;
